import clsx from "clsx";
import styles from "./Section.module.scss";

interface SectionProps {
  children: React.ReactNode;
  size?: "sm" | "md" | "lg";
  className?: string; // Add className prop to interface
}

export const Section = ({ size, children, className }: SectionProps) => {
  const sizeClasses = clsx(
    {
      "mb-6": size === "sm",
      "my-12": size === "md",
      "my-18 md:py-32 lg:py-48": size === "lg",
    },
    styles.bgGrid
  );

  // Combine sizeClasses with passed className using clsx
  const combinedClasses = clsx(sizeClasses, className);

  return <section className={combinedClasses}>{children}</section>
};